import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import PageScheffler from "./components/pages/PageScheffler";
import PageAllen from "./components/pages/PageAllen";
import PageHenderson from "./components/pages/PageHenderson";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Navigate to={"/henderson"}></Navigate>,
    },
    {
        path: "/scheffler",
        element: <PageScheffler />,
    },
    {
        path: "/allen",
        element: <PageAllen />,
    },
    {
        path: "/henderson",
        element: <PageHenderson />,
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <RouterProvider router={router}></RouterProvider>
  </React.StrictMode>
);
